import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Pages publiques qui ne nécessitent pas la sidebar
  const publicPages = ['/login', '/register', '/forgot-password', '/reset-password', '/cgu'];
  const isPublicPage = publicPages.some(path => location.pathname.startsWith(path));

  // Fermer la sidebar mobile lors du changement de route
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Pour les pages publiques, afficher uniquement le contenu sans sidebar
  if (isPublicPage) {
    return (
      <div className="arc-page">
        {children}
      </div>
    );
  }

  return (
    <div className="arc-page flex h-screen overflow-hidden">
      {/* Sidebar */}
      <div className={`
        arc-sidebar 
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
        lg:translate-x-0 lg:static lg:inset-0
        fixed inset-y-0 left-0 z-50 
        transition-transform duration-300 ease-in-out
      `}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>
      
      {/* Overlay pour mobile */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Mobile menu button - floating */}
        {isAuthenticated && (
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden fixed top-4 left-4 z-30 arc-btn-ghost p-2 bg-white shadow-lg rounded-lg"
            aria-label="Ouvrir le menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}
        
        {/* Main content area */}
        <main className="flex-1 overflow-auto bg-arc-background">
          <div className="arc-content animate-fade-in-up">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;